import { createNgReactBridgeDirective } from '../../react-bridge'
import {
  OrganizationPolicyViolationsRow,
  UserPolicyViolationsRow
} from '../../../components/notification-settings'

export const organizationPolicyViolationsNotificationSettings =
  createNgReactBridgeDirective(
    'reactOrganizationPolicyViolationsNotificationSettings',
    [],
    OrganizationPolicyViolationsRow,
    []
  )

export const userPolicyViolationsNotificationSettings =
  createNgReactBridgeDirective(
    'reactUserPolicyViolationsNotificationSettings',
    [],
    UserPolicyViolationsRow,
    []
  )
